/**
 * Constatnts
 */

// Sing in
export const SIGNIN = {
  SIGNIN_REQUEST: 'SIGNIN_REQUEST',
  SIGNIN_SUCCESS: 'SIGNIN_SUCCESS',
  SIGNIN_FAILURE: 'SIGNIN_FAILURE',
};

// Sign out
export const SIGNOUT = {
  SIGNOUT_REQUEST: 'SIGNOUT_REQUEST',
  SIGNOUT_SUCCESS: 'SIGNOUT_SUCCESS',
  SIGNOUT_FAILURE: 'SIGNOUT_FAILURE',
};
